import { Col } from "reactstrap";
import { H6, LI, UL } from "../../../../AbstractElements";
import { UnorderList } from "../../../../Constant";
import { UNORDER } from "../../../../Data/UiKit/Typography";

export const UnorderLists = () => {
  return (
    <Col sm="12" xl="4">
      <div className="card-wrapper border rounded-3">
        <H6 className="sub-title fw-bold">{UnorderList}</H6>
        <UL className="simple-list mb-3">
          <LI>One who looks on the bright side of things</LI>
          {UNORDER.map((item, index) => (
            <LI key={index}>{item.title}</LI>
          ))}
        </UL>
      </div>
    </Col>
  );
};
